import { ProductionType } from '../../../../../services/analysis.service';
import { ToolProductionType } from './tool-production-type';

export class PvsolProductionType extends ToolProductionType {
  getProductionType(): ProductionType {
    return ProductionType.PVSOL;
  }

}
